import React, { useCallback, useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../constants/pagination'
import { filterActiveOptions } from '../../../../utils/app.utils'
import * as styled from '../../style/main.style'
import { useTranslation } from 'react-i18next'
import { Button, MenuItem, Typography, ListItemText, Box } from '@mui/material'
import { ButtonContained, ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import { RouteImage } from '../../../../assets/routeImage'
import { colors } from '../../../../constants/colors'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close';

// COMPONENT
import Header from '../../Header'
import Navbar from '../../Navbar'
import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import FilterSelect from '../../../../component/select/filterSelect'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import TableCustom from '../../../../component/table/tableCustom'
import CheckboxPermission from '../../../../component/checkboxPermission/checkboxPermission'
import Loading from '../../../../component/loading/Loading'
import { notificationSwal } from '../../../../utils/notification.swal'
import { swalSuccess } from '../../../../component/notification/swal'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import ModalCustom from '../../../../component/modal/ModalCustom'
import InputTextField from '../../../../component/input/inputTextField'

// STORE
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'

// API
// import { Permission } from '../../../../constants/permission'
import { RolesApi, rolesType, rolesTypeProps } from '../../../../api/roles/roles.api';
import AutocompleteSelect from '../../../../component/select/autoCompleteSelect'
import ButtonCustom from '../../../../component/button/buttonCustom'

interface Action {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

interface Role {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

const PermissionSetting: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)
    const permissions = useSelector((state: any) => state?.permission?.permission)


    // console.log(JSON.stringify(Permission))

    const [rolesData, setRolesData] = useState<any>(null);
    const [allRoles, setAllRoles] = useState<Role[]>([]);
    const [permission, setPermission] = useState<Role[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [keyword, setKeyword] = useState<string>("");
    const [showModalAddModal, setShowAddModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [roleId, setRoleId] = useState<number>(Number);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const [roleDetail, setRoleDetail] = useState<rolesTypeProps>({
        roleName: "",
        roleStatus: "",
        permission: []
    });
    const [addRoles, setAddRoles] = useState<rolesTypeProps>({
        roleStatus: t("STATUS.ACTIVE"),
        roleName: "",
        permission: []
    })

    const handleChangeStatus = (event: React.ChangeEvent<HTMLSelectElement>) => setAddRoles({ ...addRoles, roleStatus: event.target.value })
    const handleToggleModal = () => {
        setAddRoles(
            {
                roleStatus: t("STATUS.ACTIVE"),
                roleName: "",
                permission: []
            }
        )
        setPermission([])
        setShowAddModal(!showModalAddModal)
    }
    const handleToggleModalEdit = () => setShowEditModal(!showEditModal)

    const handleEdit = async (id: number) => {
        dispatch(setLoading())
        handleToggleModalEdit()
        setRoleId(id)
        await RolesApi.getDetail(id)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setPermission(res.data?.result?.permission)
                    const { roleName, roleStatus } = res.data?.result
                    setRoleDetail((prev) => ({ ...prev, roleName: roleName, roleStatus: roleStatus }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleChangeRoles = async (roleId: number, roleName: string, status: string) => {
        dispatch(setLoading())
        let condition: rolesTypeProps = {
            roleName: roleName,
            roleStatus: status,
            permission: permission
        }
        await RolesApi.changeRoles(roleId, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                    handleGetRoles()
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleAddRoles = async (event: React.FormEvent) => {
        event.preventDefault();
        dispatch(setLoading())
        await RolesApi.createRoles(addRoles)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => {
                handleToggleModal()
                handleGetRoles()
            })
    }
    const handleEditRoles = async (event: React.FormEvent) => {
        event.preventDefault();
        let condition: rolesTypeProps = {
            ...roleDetail,
            permission: permission
        }
        dispatch(setLoading())
        await RolesApi.changeRoles(roleId, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                    swalSuccess(notificationSwal.success)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalSuccess(notificationSwal.error)
                console.log(error)
            })
            .finally(() => {
                handleToggleModalEdit()
                handleGetRoles()
            })
    }

    const headCells = [
        {
            id: "roleName", disablePadding: false, align: 'left', sortable: true, label: "บทบาท"
        },
        {
            id: "STATUS", disablePadding: true, align: 'center', label: "สถานะ"
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ]
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idRole, roleName, roleStatus } =
            objData;

        const objRenderData = {
            key: idRole,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "left", label: roleName,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component:
                        <div className='max-w-[153px]'>
                            <FilterSelect
                                disabled={permissions?.find((list: any) => list?.code === "Permission.Edit")?.permit === false}
                                headingNormal
                                renderValue={() =>
                                    <ListItemText className='relative'>
                                        {roleStatus === t("STATUS.ACTIVE") ? (
                                            <Typography
                                                className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                                {t("STATUS.ACTIVE")}
                                            </Typography>
                                        ) : (
                                            <Typography
                                                className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                                {t("STATUS.INACTIVE")}
                                            </Typography>
                                        )}
                                    </ListItemText>
                                }

                                label={t('STATUS.LABEL')}
                                selectId="select-fiscal-year"
                                value={roleStatus}
                                labelId="label-fiscal-year"
                                onchange={(e) => handleChangeRoles(idRole, roleName, e.target.value)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <Typography className='text-light_success'> <li>{t("STATUS.ACTIVE")}</li></Typography>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <Typography className='text-danger'> <li>{t("STATUS.INACTIVE")}</li></Typography>
                                    </MenuItem>
                                ]}
                            />
                        </div>,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    },
                    width: 10,
                    component:
                        <div
                            style={{
                                display: permissions?.find((list: any) => list?.code === "Permission.Edit")?.permit === false ? 'none' : ''
                            }}
                            className='flex gap-2'>
                            <Button
                                onClick={() => handleEdit(idRole)}
                                startIcon={<img src={RouteImage.editPen} />}
                                sx={disableStyleButtonMui}>{"แก้ไข"}
                            </Button>
                            {/* <Button className='cursor-pointer w-[24px]'>
                                <img src={RouteImage.detailIcon} width={24} alt="icons" />
                            </Button> */}
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    }
    const handleGetRoles = useCallback(async () => {
        dispatch(setLoading())
        let condition: rolesType = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, limit: pageLimit }
        if (keyword) condition = { ...condition, keyword: keyword }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        await RolesApi.getRoles(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setRolesData(res.data?.result?.items)
                    setTotalItems(res.data?.result?.meta?.totalItems)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit, keyword, sortBy, sortType])

    useEffect(() => {
        handleGetRoles();
    }, [handleGetRoles])



    const handleCheckboxChange = (node: any, checked: boolean) => {
        const updatedData = updateData([...permission], node, checked);
        setPermission(updatedData);
    };
    const updatePermit = (data: any, checked: boolean) => {
        return data?.map((item: any) => {
            const updatedItem = { ...item, permit: checked };
            if (item.actions && item.actions.length > 0) {
                updatedItem.actions = updatePermit(item.actions, checked);
            }
            return updatedItem;
        });
    };
    const updateData = (arr: any, targetNode: any, checked: boolean) => {
        return arr.map((node: any) => {
            if (node.code === targetNode.code) {
                return { ...node, permit: checked, actions: checked ? targetNode.actions : updatePermit(node.actions, false) };
            } else if (node.actions && node.actions.length > 0) {
                return { ...node, actions: updateData(node.actions, targetNode, checked) };

            }
            return node;
        });
    };

    const updateAll = (data: any) => {
        setPermission(updatePermit(data, true))
    }

    const getNewRole = async (id: any) => {
        if (id) {
            RolesApi.getRole({ idRole: id }).then((res) => {
                if (res?.data?.success) {
                    setAddRoles(res.data.result);
                    setPermission(res.data.result.permission)
                }
            });
        }

    }
    const getAllRoles = async () => {
        let condition: any = { limit: LIMIT_ALL };

        RolesApi.getAllRoles(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setAllRoles(items);

            }
        });
    }
    useEffect(() => {
        getAllRoles()
    }, [])
    useEffect(() => {
        const permissionCheck = permissions?.find((list: any) => list?.code === "Permission.Read" || "Permission.Open ")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            {showModalAddModal && (
                <ModalCustom
                    buttonType='submit'
                    maxHeight={'auto'}
                    alignHeader='center'
                    heading='เพิ่มบทบาท'
                    componentHeight={addRoles?.roleName ? '650px' : 'auto'}
                    component=
                    {
                        <form onSubmit={handleAddRoles} className='w-full'>
                            <Box className='w-full mt-8 flex flex-col gap-5'>
                                <CloseIcon
                                    onClick={() => handleToggleModal()}
                                    className='text-danger cursor-pointer absolute top-0 right-0 mt-5 mr-5'
                                />
                                <span className='grid grid-cols-6 gap-[10px]'>
                                    <div className='col-span-6 md:col-span-6'>
                                        {/* <InputTextField
                                            required
                                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setAddRoles({ ...addRoles, roleName: e.target.value })}
                                            value={addRoles.roleName}
                                            heading='ตำแหน่ง'
                                        /> */}

                                        <AutocompleteSelect labelId={''}
                                            placeholder={'ตำแหน่ง'}
                                            // inputLabel={t('ROLE_CREATE.INPUT.ROLE')}
                                            required
                                            heading={'ตำแหน่ง'}
                                            options={filterActiveOptions(allRoles, 'roleStatus', 'idRole', [(addRoles as any)?.idRole])}
                                            getOptionLabel={(option) => option.roleName || ''}
                                            value={addRoles}
                                            onChange={(e: any, value: any) => {
                                                setAddRoles(value)
                                                // clearErrorMessage();
                                                getNewRole(value?.idRole)
                                            }}
                                        // helperText={
                                        //     errorMessage.ROLE || ''
                                        // }
                                        // disabled={idRole}
                                        />
                                    </div>
                                </span>
                                <span>
                                    <FilterSelect
                                        required
                                        heading='สถานะ'
                                        headingNormal
                                        label={t('STATUS.LABEL')}
                                        selectId="select-fiscal-year"
                                        value={addRoles?.roleStatus || ''}
                                        labelId="label-fiscal-year"
                                        onchange={handleChangeStatus}
                                        options={[
                                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                                <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                            </MenuItem>,
                                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                                <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                            </MenuItem>
                                        ]}
                                    />
                                </span>
                                {permission?.length > 0 &&
                                    <>
                                        <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>{'กำหนดฟังก์ชัน'}</Typography>
                                        <ButtonCustom textButton={'เลือกทั้งหมด'} onClick={() => updateAll(permission)} />
                                    </>
                                }
                                <div>
                                    {permission && permission?.map((list: any) => (
                                        <CheckboxPermission
                                            node={list}
                                            onCheckboxChange={handleCheckboxChange}
                                        />
                                    ))}
                                </div>
                                <span className='mt-3 flex items-center justify-center'>
                                    <ButtonContained
                                        type='submit'
                                        sx={{ maxWidth: 90 }}
                                    >
                                        {t("BUTTON.SAVE")}
                                    </ButtonContained>
                                </span>
                            </Box>
                        </form>
                    }
                />
            )}
            {
                showEditModal && (
                    <ModalCustom
                        alignHeader='center'
                        heading='แก้ไขสิทธิ์'
                        maxHeight='auto'
                        componentHeight='600px'
                        enableExit={handleToggleModalEdit}
                        component={
                            <form onSubmit={handleEditRoles} className='w-full'>
                                <Box className='w-full mt-8 flex flex-col gap-5'>
                                    <CloseIcon
                                        onClick={handleToggleModalEdit}
                                        className='text-danger cursor-pointer absolute top-0 right-0 mt-5 mr-5'
                                    />
                                    <span className='grid grid-cols-6 gap-[10px]'>
                                        <div className='col-span-6 md:col-span-6'>
                                            {/* <InputTextField
                                            required
                                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleDetail((prev) => ({ ...prev, roleName: e.target.value }))}
                                            value={roleDetail && roleDetail?.roleName}
                                            heading='ตำแหน่ง'
                                        /> */}
                                            <AutocompleteSelect labelId={''}
                                                placeholder={'ตำแหน่ง'}
                                                // inputLabel={t('ROLE_CREATE.INPUT.ROLE')}
                                                required
                                                heading={'ตำแหน่ง'}
                                                options={allRoles}
                                                getOptionLabel={(option) => option.roleName || ''}
                                                value={roleDetail}
                                                onChange={(e: any, value: any) => {
                                                    setRoleDetail(value)
                                                    // clearErrorMessage();
                                                    getNewRole(value?.idRole)
                                                }}
                                                // helperText={
                                                //     errorMessage.ROLE || ''
                                                // }
                                                disabled={roleDetail?.roleName ? true : false}
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <FilterSelect
                                            required
                                            heading='สถานะ'
                                            headingNormal
                                            label={t('STATUS.LABEL')}
                                            selectId="select-fiscal-year"
                                            value={roleDetail && roleDetail?.roleStatus}
                                            labelId="label-fiscal-year"
                                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setRoleDetail((prev) => ({ ...prev, roleStatus: e.target.value }))}
                                            options={[
                                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                                    <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                                </MenuItem>,
                                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                                    <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                                </MenuItem>
                                            ]}
                                        />
                                    </span>
                                    {permission?.length > 0 &&
                                        <>
                                            <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>{'กำหนดฟังก์ชัน'}</Typography>
                                            <ButtonCustom textButton={'เลือกทั้งหมด'} onClick={() => updateAll(permission)} />
                                        </>
                                    }
                                    <div>
                                        {permission && permission?.map((list: any) => (
                                            <CheckboxPermission
                                                node={list}
                                                onCheckboxChange={handleCheckboxChange}
                                            />
                                        ))}
                                    </div>
                                    <span className='mt-3 flex items-center justify-center'>
                                        <ButtonContained
                                            type='submit'
                                            sx={{ maxWidth: 90 }}>
                                            {t("BUTTON.SAVE")}
                                        </ButtonContained>
                                    </span>
                                </Box>
                            </form>}
                    />
                )
            }
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <div>
                            <Typography className='text-primary' variant='h4'>
                                {"จัดการบทบาท"}
                            </Typography>
                        </div>
                        <span
                            style={{
                                display: permissions?.find((list: any) => list?.code === "Permission.Create")?.permit === false ? 'none' : ''
                            }}
                        >
                            <ButtonOutlined
                                onClick={handleToggleModal}
                                startIcon={<img src={RouteImage.addButton} />}>
                                <Typography className='text-primary'> {t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        </span>
                    </styled.TopicHeader>
                    <section className='mt-8 w-full h-auto'>
                        {rolesData && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={rolesData.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}

                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome >
    )
}

export default PermissionSetting